import axios from 'axios';
import "nprogress/nprogress.css";
import NProgress from "nprogress";

axios.interceptors.request.use(function (config) {
    NProgress.start();
    config.headers['Authorization'] = localStorage.getItem("token");
    config.headers['Time-Location'] = localStorage.getItem("time-location");
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    NProgress.done();
    // 对响应数据做点什么
    return response;
  }, function (error) {
    NProgress.done();
    // 对响应错误做点什么
    return Promise.reject(error);
});

// 使用form 方式请求
const requestForm = ()=>{
  // const instance = axios.create();
  // instance.interceptors.request.use(function (config) {
  //   config.headers.Authorization = localStorage.getItem("token");
  //   return config;
  //   }, function (error) {
  //     // 对请求错误做些什么
  //     return Promise.reject(error);
  // });
  // instance.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  return axios
}

// 使用json方式请求
const requestJson = ()=>{
  // const instance = axios.create();
  // instance.interceptors.request.use(function (config) {
  //   config.headers.Authorization = localStorage.getItem("token");
  //   return config;
  //   }, function (error) {
  //     // 对请求错误做些什么
  //     return Promise.reject(error);
  // });
  // instance.defaults.headers['Content-Type'] = 'application/json';
  axios.defaults.headers['Content-Type'] = 'application/json';
  return axios
}

export {
  requestForm,
  requestJson,
}